// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3LTlg","title":"AfterBackImages_title__3f-sK","images":"AfterBackImages_images__NLsy7"};